/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { useTheme } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const Border = 1;

const styles = {
  logo: (theme: Theme, width: number, padding: number, borderRadius: number) => css`
    flex-shrink: 0;
    border-radius: ${borderRadius}px;
    overflow: hidden;
    width: ${width}px;
    height: ${width}px;
    padding: ${padding}px;
    border: ${Border}px solid ${theme.palette.gray[300]};
  `,
};

type Props = {
  src: string;
  name?: string;
  width?: number;
  borderRadius?: number;
};

const PartnerSquareLogo = ({ src, name, width = 50, borderRadius = 8 }: Props) => {
  const theme = useTheme();
  if (!src) {
    return null;
  }

  const padding = Math.floor(width / 10);
  const imageSize = width - padding * 2 - Border * 2;

  return (
    <div css={styles.logo(theme, width, padding, borderRadius)}>
      <Imgix src={src} alt={name ?? ''} maxWidth={imageSize} maxHeight={imageSize} imgParams={{ fit: 'fill' }} />
    </div>
  );
};

export default PartnerSquareLogo;
